import React, { useEffect } from 'react';
import { Space, Card } from 'antd';
import { dateFormat } from '../utils';
import W from '../assets/W.png';
import U from '../assets/U.png';
import B from '../assets/B.png';
import R from '../assets/R.png';
import G from '../assets/G.png'; 

const arrayColorsIcon = {
    'W': W,
    'U': U,
    'B': B,
    'R': R,
    'G': G
}

function ShowDeckColors(props) {
    // console.warn('props di showdeckcolors', props);
    if (props.archetypes && props.archetypes.data && props.archetypes.data.payLoad) {
        let deckInfos = '';
        const retVal = [];
        props.archetypes.data.payLoad.forEach((currentItem, index) => {
            if (currentItem.name === props.deck.deckName) {
                deckInfos = currentItem.colorIdentity;
            }        
        })
        if (deckInfos !== '') {
            const colors = deckInfos.split(",")
            colors.forEach((currentItem) =>{
                retVal.push(<span><img src={arrayColorsIcon[currentItem]} style={{ width: '16px'}}/></span>)
            })
        }
        return (<>
            {retVal.map(color => color)}
        </>)
    } 

    return (<Space></Space>)
}

export default ShowDeckColors;